import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../../enum/enum";
import { useLoader } from "../../../context/loaderContext";
import { useAuth } from "../../../context/authContext";
import Layout from "../../../layout/layout";
import moment from "moment";

const SponsorBusiness = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [sponsorBusiness, setSponsorBusiness] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const getSponsorBusiness = async () => {
        try {
            const url = `${BaseUrl}Dashboard/SponserBusinessDetail`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "userID": userId,
                    "version": Version
                },
                "request": {
                    "FromDate": fromDate ? moment(fromDate).format("DD-MMM-YYYY") : "",
                    "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY") : "",
                    "BusinessType": "0",
                    "IsRecent": toDate || fromDate ? false : true,
                    "LevelNo": 0,
                    "SearchType": 0,
                    "SponserId": "0"
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setSponsorBusiness(res.data.data || []);
            } else {
                setSponsorBusiness([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getSponsorBusiness();
        setFromDate(moment(new Date()).format(("YYYY-MM-DD")));
        setToDate(moment(new Date()).format(("YYYY-MM-DD")));
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Sponsor Business </h5>
                                    </div>
                                    {/* filters */}
                                    {/* {sponsorBusiness?.length > 0 && ( */}
                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>
                                        {/* <div>
                                            <label className="form-label">From User</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="From User..."
                                                value={fromUser}
                                                onChange={(e) => setFromUser(e.target.value)}
                                            />
                                        </div> */}
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getSponsorBusiness}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>
                                    {/* // )} */}
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            sponsorBusiness?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">User Id</th>
                                                                <th scope="col">User Name</th>
                                                                <th scope="col">Amount</th>
                                                                <th scope="col">Business Type</th>
                                                                <th scope="col">Activation Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                sponsorBusiness?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.strUserId}</td>
                                                                        <td>{el.username}</td>
                                                                        <td>${el.amount}</td>
                                                                        <td>{el.businessType}</td>
                                                                        <td>{el.activationDate}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {sponsorBusiness?.length > 0 ? (
                                            sponsorBusiness.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.activationDate}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>User Id:</strong>
                                                        <p className="mb-0 f-w-500">{el.strUserId}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>User Name:</strong>
                                                        <p className="mb-0 f-w-500">{el.username}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Amount:</strong>
                                                        <p className="mb-0 f-w-500">${el.amount}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Business Type:</strong>
                                                        <p className="mb-0 f-w-500">{el.businessType}</p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default SponsorBusiness;